module.exports = __webpack_public_path__ + "media/images/prediction/special/auto/img_thumb_auto-f1ee405735daa4b1ee48d4567d967a12.jpg";